import { uniqBy } from 'lodash';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useRiskObjectsByParty } from '../../../../../../../parties/src/features/risk-objects/api/getAllRiskObjectByParty';
import {
  InsurancePolicies,
  InsurancePolicy,
} from '../../../../../types/AdvisoryReport';

/** Retrieving the custom riskobjects that are not in the party data but only in the coverages + if partyId given, include party risk objects  */
const useCustomRiskObjectsFromPolicies = (
  policies?: InsurancePolicies,
  partyId?: string,
) => {
  const { t } = useTranslation();

  const { data: partyRiskObjects } = useRiskObjectsByParty(partyId, 'v2');

  const partyRiskObjectOptions = Object.values(partyRiskObjects || {})
    .flat()
    .map(({ name, risk_object_id }) => ({
      label: name,
      value: risk_object_id,
    }));

  const allPolicies = Object.values(policies || {}).flat() as InsurancePolicy[];

  const allCustomRiskObjects = allPolicies.flatMap(
    ({ coverages }) =>
      coverages?.map(({ risk_object, risk_object_id }) => ({
        label: risk_object || t('OTHER') || '',
        value: risk_object_id || risk_object || '',
      })) || [],
  );

  return useMemo(
    () =>
      policies
        ? uniqBy([...allCustomRiskObjects, ...partyRiskObjectOptions], 'label')
        : [],
    [policies, partyRiskObjects],
  );
};
export default useCustomRiskObjectsFromPolicies;
